import { setActivePinia } from 'pinia'
import { useNuxtApp } from 'nuxt/app'

import { getShowBetaPreviewFromUrl } from '../utils/show-beta-preview-url.utils'

import { useBetaPreviewUIStore } from '../stores/beta-preview.ui-store'

import type { Pinia } from 'pinia'

export default defineNuxtRouteMiddleware(to => {
  const env = process.server ? 'server' : 'client'
  const nuxtApp = useNuxtApp()
  const pinia = nuxtApp.$pinia as Pinia | undefined

  if (!pinia) {
    return
  }

  setActivePinia(pinia)

  const raw = getShowBetaPreviewFromUrl(to.fullPath)

  if (raw != null) {
    const store = useBetaPreviewUIStore()
    store.setShowBetaPreview(raw)
  }
})
